














import {Vue, Component} from 'vue-property-decorator';
import {ICellRendererParams} from "ag-grid-community";

@Component({
  name: "grid-line-actions-component",
})
export default class GridLineActionsComponent extends Vue {
  private params!: ICellRendererParams;

  get isFirst(): boolean {
    return this.params?.node?.rowIndex === 0;
  }

  get isLast(): boolean {
    return this.params?.node?.rowIndex === this.params?.api?.getDisplayedRowCount() - 1;
  }

  onMove(direction: number): void {
    const parentContext = this.params?.context?.componentParent;

    if (parentContext && typeof parentContext.moveRowNode === 'function') {
      parentContext.moveRowNode(this.params?.node?.rowIndex, direction);
    } else {
      console.warn("Method `moveRowNode` unknown in parent context.");
    }
  }

  onDelete(): void {
    const parentContext = this.params?.context?.componentParent;

    if (parentContext && typeof parentContext.deleteRowNode === 'function') {
      parentContext.deleteRowNode(this.params?.data, this.params?.node?.rowIndex);
    } else {
      console.warn("Method `deleteRowNode` unknown in parent context.");
    }
  }
}
